import { addCollection, Icon as Ic } from "@iconify/react";
import solar from "@iconify-json/solar/icons.json";
import ph from "@iconify-json/ph/icons.json";
import heroicons from "@iconify-json/heroicons/icons.json";
import vscodeIcons from "@iconify-json/vscode-icons/icons.json";
import nrk from "@iconify-json/nrk/icons.json";
import ep from "@iconify-json/ep/icons.json";
import ion from "@iconify-json/ion/icons.json";
import eva from "@iconify-json/eva/icons.json";
import ic from "@iconify-json/ic/icons.json";
import fa from "@iconify-json/fa/icons.json";
import mage from "@iconify-json/mage/icons.json";
import quill from "@iconify-json/quill/icons.json";
import teenyicons from "@iconify-json/teenyicons/icons.json";
import qlementineIcons from "@iconify-json/qlementine-icons/icons.json";
import fa6Solid from "@iconify-json/fa6-solid/icons.json";
import bi from "@iconify-json/bi/icons.json";
import iconoir from "@iconify-json/iconoir/icons.json";
import tabler from "@iconify-json/tabler/icons.json";
import f7 from "@iconify-json/f7/icons.json";

addCollection(solar);
addCollection(ph);
addCollection(heroicons);
addCollection(vscodeIcons);
addCollection(nrk);
addCollection(ep);
addCollection(ion);
addCollection(eva);
addCollection(ic);
addCollection(fa);
addCollection(mage);
addCollection(quill);
addCollection(teenyicons);
addCollection(qlementineIcons);
addCollection(fa6Solid);
addCollection(bi);
addCollection(iconoir);
addCollection(tabler);
addCollection(f7);

const Icon = ({ icon, className, width, rotate, hFlip, vFlip, ...props }) => {
  return (
    <Ic
      width={width}
      rotate={rotate}
      hFlip={hFlip}
      icon={icon}
      className={className}
      vFlip={vFlip}
      {...props}
    />
  );
};

export default Icon;
